import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import corosSrc from './images/send-to-coros-thumb.avif';

// https://www.figma.com/design/vV97hwFyKhekbcMy2TuNyz/Feature-Merchandising?node-id=840-95326&t=XlR2wnwWYYfdIIZ3-4
const connectGarminCoros = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Connect Garmin & COROS' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Sync your wearable for routes and activity tracking' }),
  thumbnailImage: corosSrc.src
});

export default connectGarminCoros;
